import { create } from 'zustand';

interface ScrollState {
  isContentScrolled: boolean;
  setIsContentScrolled: (scrolled: boolean) => void;
}

export const useScrollStore = create<ScrollState>((set) => ({
  isContentScrolled: false,
  setIsContentScrolled: (scrolled) => set({ isContentScrolled: scrolled }),
}));
